import React, { useCallback } from 'react';

import Input from '../../components/Input';

function HeaderElementForm({ element, onChange }) {
  const handleChangeLabel = useCallback(e => {
    onChange({
      ...element,
      data: {
        ...element.data,
        label: e.target.value
      }
    });
  }, [element, onChange]);

  return (
    <Input
      large
      defaultValue={element.data.label}
      onBlur={handleChangeLabel}
    />
  );
}

export default HeaderElementForm;